import { BaseService } from '../../../infra/base.service'
import type { FormDataLastEmissionDto } from './dto/form-data-last-emission.dto'
import type { FormData } from './form-data'
import type { FormDatasRepository } from './form-datas.repository'

export class FormDatasService extends BaseService<FormData> {
    constructor(private rep: FormDatasRepository) {
        super(rep)
    }

    async publicGetOne(companyId: string, formDataId: string) {
        return this.rep.publicGetOne(companyId, formDataId)
    }

    async publicUpdate(companyId: string, formDataId: string, entity: Partial<FormData>) {
        return this.rep.publicUpdate(formDataId, companyId, entity)
    }

    async publicGetOneByLink(formDataLinkId: string, token: string) {
        return this.rep.publicGetOneByLink(formDataLinkId, token)
    }

    async publicUpdateByLink(formDataLinkId: string, token: string, entity: Partial<FormData>) {
        return this.rep.publicUpdateByLink(formDataLinkId, token, entity)
    }

    async findLastEmissionsFromPerson(personId: string, formDataIds: string[]): Promise<FormDataLastEmissionDto[]> {
        return await this.rep.findLastEmissionsFromPerson(personId, formDataIds)
    }

    async getSignedDocumentUrl(formDataId: string): Promise<{ url: string }> {
        return await this.rep.getSignedDocumentUrl(formDataId)
    }
}
